import { RenderingProps } from '@/shared/shared.types';
import {
  ComponentParams,
  ImageField,
  Field,
  RichTextField,
  FileField,
} from '@sitecore-jss/sitecore-jss-nextjs';

export type C43MediaGalleryItemProps = RenderingProps<C43MediaGalleryItemFields> & {
  params?: ComponentParams;
};

export interface C43MediaGalleryItemFields {
  Image?: ImageField;
  VideoID?: Field<string>;
  AudioSource?: FileField;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
}
